// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2kvHR","head":"Table_head__3hzRq","col":"Table_col__nkgJ5"};